import React, { useMemo, useState } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

const RulesPanel: React.FC = () => {
  const { theme } = useAITTheme();
  const [isOpen, setIsOpen] = useState(false);
  const styles = useMemo(() => getStyles(theme, isOpen), [theme, isOpen]);

  const handleToggle = () => setIsOpen(!isOpen);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <button type="button" style={styles.toggleButton} onClick={handleToggle}>
        📋 出張ルール
      </button>
      {isOpen && (
        <div
          role="button"
          tabIndex={0}
          aria-label="パネルを閉じる"
          style={styles.overlay}
          onClick={handleClose}
          onKeyDown={e => e.key === 'Escape' && handleClose()}
        />
      )}
      <div style={styles.container}>
        <div style={styles.header}>
          <h3 style={styles.headerTitle}>会社の出張ルール</h3>
          <button type="button" style={styles.closeButton} onClick={handleClose}>
            ✕
          </button>
        </div>
        <div style={styles.content}>
          <p style={styles.placeholder}>※以下は仮項目です（ハードコーディング）</p>
          <h4 style={styles.sectionTitle}>会社の出張ルール</h4>
          <ul style={styles.list}>
            <li>事前申請: 国内/海外ともに必要</li>
            <li>宿泊規程: 規程超過あり（朝食設定なし）</li>
            <li>航空券規程: 国内・海外とも普通席のみ</li>
            <li>新幹線・特急: 指定席、EXIC/ビジネスえきねっと利用可</li>
          </ul>
          <h4 style={styles.sectionTitle}>あなたの設定・嗜好性</h4>
          <ul style={styles.list}>
            <li>Google Calendar 連携: 未設定</li>
            <li>slack 連携: 未設定</li>
            <li>salesforce 連携: 未設定</li>
          </ul>
        </div>
      </div>
    </>
  );
};

const getStyles = (theme: AITTheme, isOpen: boolean) => ({
  toggleButton: {
    position: 'fixed' as const,
    right: '20px',
    bottom: '200px',
    backgroundColor: theme.linkColor,
    color: '#ffffff',
    border: 'none',
    padding: '12px 16px',
    borderRadius: '24px',
    fontSize: '13px',
    fontWeight: 600 as const,
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(0, 128, 203, 0.3)',
    zIndex: 900,
    display: 'flex' as const,
    alignItems: 'center' as const,
    gap: '6px'
  },
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 999
  },
  container: {
    position: 'fixed' as const,
    right: isOpen ? 0 : -280,
    top: 0,
    width: '280px',
    height: '100vh',
    backgroundColor: '#fcfcfc',
    borderLeft: `1px solid ${theme.grayBorderColor}`,
    overflowY: 'auto' as const,
    zIndex: 1000,
    transition: 'right 0.3s ease-in-out',
    boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.15)'
  },
  header: {
    padding: '16px 20px',
    backgroundColor: '#1b1b1b',
    color: '#ffffff',
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'space-between' as const
  },
  headerTitle: {
    fontSize: '16px',
    fontWeight: 600 as const,
    margin: 0
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: '#ffffff',
    fontSize: '18px',
    cursor: 'pointer',
    padding: '4px 8px'
  },
  content: {
    padding: '20px'
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 600 as const,
    margin: '16px 0 8px',
    color: theme.textColor
  },
  list: {
    margin: 0,
    paddingLeft: '16px',
    color: theme.grayTextColor,
    lineHeight: 1.6,
    fontSize: '13px'
  },
  placeholder: {
    margin: '0 0 12px',
    padding: '8px 12px',
    backgroundColor: '#fff3cd',
    border: '1px solid #ffc107',
    borderRadius: '4px',
    fontSize: '12px',
    color: '#856404'
  }
});

export default RulesPanel;
